module.exports = __webpack_public_path__ + "img/case-logo-30.07af5411.png";